import { createIcon } from "@chakra-ui/react";

export const ChevronUp = createIcon({
  displayName: "ChevronUp",
  viewBox: "0 0 24 24",
  d: "M12.941 8.477a1.135 1.135 0 0 0-1.549 0L4.83 14.728a1.009 1.009 0 0 0 0 1.475 1.135 1.135 0 0 0 1.549 0l5.79-5.515L17.96 16.2a1.135 1.135 0 0 0 1.549 0 1.009 1.009 0 0 0 0-1.475l-6.563-6.25-.004.002z",
  defaultProps: {
    "aria-label": "A chevron pointing up"
  }
});

export default ChevronUp;
